import { isValidTimezone } from './timezone-helpers/is-valid-timezone';

type CronScheduledSyncTimezoneValidation = { valid: true } | { message: string; valid: false };

export function validateCronScheduledSyncTimezone(
  timezone?: string,
  cronScheduledSync?: string
): CronScheduledSyncTimezoneValidation {
  if (cronScheduledSync == null || cronScheduledSync === 'None') {
    return { valid: true };
  }

  if (!timezone?.trim()) {
    return { message: 'Timezone is required for scheduled sync', valid: false };
  }

  if (!isValidTimezone(timezone)) {
    return { message: 'Invalid timezone', valid: false };
  }

  return { valid: true };
}
